// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Content from "./content.js"
import ContentAbsoluteContainer from "./content-absolute-container.js"
import ContentPieceType from "./content-piece-type.js"
import ScoreFactor from "./score-factor.js"
import SurveyStep from "./survey-step.js"
import SurveyStepElementOption from "./survey-step-element-option.js"

const modelClassData = {
  "attributes": {
    "content": {
      "column": null,
      "name": "content",
      "selected_by_default": null,
      "translated": false
    },
    "content_piece_type_id": {
      "column": {
        "default": null,
        "name": "content_piece_type_id",
        "null": true,
        "type": null
      },
      "name": "content_piece_type_id",
      "selected_by_default": null,
      "translated": false
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "editable": {
      "column": {
        "default": "1",
        "name": "editable",
        "null": false,
        "type": "boolean"
      },
      "name": "editable",
      "selected_by_default": null,
      "translated": false
    },
    "element_type": {
      "column": {
        "default": null,
        "name": "element_type",
        "null": false,
        "type": "string"
      },
      "name": "element_type",
      "selected_by_default": null,
      "translated": false
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "identifier": {
      "column": {
        "default": null,
        "name": "identifier",
        "null": true,
        "type": "string"
      },
      "name": "identifier",
      "selected_by_default": null,
      "translated": false
    },
    "min_choices": {
      "column": {
        "default": null,
        "name": "min_choices",
        "null": true,
        "type": "integer"
      },
      "name": "min_choices",
      "selected_by_default": null,
      "translated": false
    },
    "max_choices": {
      "column": {
        "default": null,
        "name": "max_choices",
        "null": true,
        "type": "integer"
      },
      "name": "max_choices",
      "selected_by_default": null,
      "translated": false
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": null,
      "translated": true
    },
    "position": {
      "column": {
        "default": "0",
        "name": "position",
        "null": false,
        "type": "integer"
      },
      "name": "position",
      "selected_by_default": null,
      "translated": false
    },
    "score_factor_id": {
      "column": {
        "default": null,
        "name": "score_factor_id",
        "null": true,
        "type": null
      },
      "name": "score_factor_id",
      "selected_by_default": null,
      "translated": false
    },
    "state": {
      "column": {
        "default": "draft",
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": false
    },
    "survey_step_id": {
      "column": {
        "default": null,
        "name": "survey_step_id",
        "null": false,
        "type": null
      },
      "name": "survey_step_id",
      "selected_by_default": null,
      "translated": false
    },
    "translated_element_type": {
      "column": null,
      "name": "translated_element_type",
      "selected_by_default": null,
      "translated": false
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": null,
      "translated": false
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    },
    "parsed_content": {
      "column": null,
      "name": "parsed_content",
      "selected_by_default": false,
      "translated": false
    },
    "parsed_main_content": {
      "column": null,
      "name": "parsed_main_content",
      "selected_by_default": false,
      "translated": false
    },
    "main_content": {
      "column": null,
      "name": "main_content",
      "selected_by_default": false,
      "translated": true
    },
    "main_content_da": {
      "column": null,
      "name": "main_content_da",
      "selected_by_default": false,
      "translated": false
    },
    "main_content_en": {
      "column": null,
      "name": "main_content_en",
      "selected_by_default": false,
      "translated": false
    },
    "main_content_no": {
      "column": null,
      "name": "main_content_no",
      "selected_by_default": false,
      "translated": false
    },
    "main_content_se": {
      "column": null,
      "name": "main_content_se",
      "selected_by_default": false,
      "translated": false
    },
    "name_da": {
      "column": null,
      "name": "name_da",
      "selected_by_default": false,
      "translated": false
    },
    "name_en": {
      "column": null,
      "name": "name_en",
      "selected_by_default": false,
      "translated": false
    },
    "name_no": {
      "column": null,
      "name": "name_no",
      "selected_by_default": false,
      "translated": false
    },
    "name_se": {
      "column": null,
      "name": "name_se",
      "selected_by_default": false,
      "translated": false
    }
  },
  "className": "SurveyStepElement",
  "collectionKey": "survey_step_elements",
  "collectionName": "survey_step_elements",
  "i18nKey": "survey_step_element",
  "camelizedLower": "surveyStepElement",
  "name": "SurveyStepElement",
  "nameDasherized": "survey-step-element",
  "pluralName": "survey_step_elements",
  "ransackable_associations": [
    {
      "className": "SurveyStepElement::Audit",
      "collectionName": "survey_step_element_audits",
      "foreignKey": "survey_step_element_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "SurveyStepElementAudit",
      "through": null
    },
    {
      "className": "ContentAbsoluteContainer",
      "collectionName": "content_absolute_containers",
      "foreignKey": "survey_step_element_id",
      "name": "content_absolute_container",
      "macro": "has_one",
      "resource_name": "ContentAbsoluteContainer",
      "through": null
    },
    {
      "className": "Content",
      "collectionName": "contents",
      "foreignKey": "resource_id",
      "name": "content_model",
      "macro": "has_one",
      "resource_name": "Content",
      "through": null
    },
    {
      "className": "ContentPieceType",
      "collectionName": "content_piece_types",
      "foreignKey": "content_piece_type_id",
      "name": "content_piece_type",
      "macro": "belongs_to",
      "resource_name": "ContentPieceType",
      "through": null
    },
    {
      "className": "Content",
      "collectionName": "contents",
      "foreignKey": "resource_id",
      "name": "contents",
      "macro": "has_many",
      "resource_name": "Content",
      "through": null
    },
    {
      "className": "SurveyStepElement::Audit",
      "collectionName": "survey_step_element_audits",
      "foreignKey": "survey_step_element_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "SurveyStepElementAudit",
      "through": null
    },
    {
      "className": "SurveyStepElement::Translation",
      "collectionName": null,
      "foreignKey": "survey_step_element_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "SurveyStepElementOption",
      "collectionName": "survey_step_element_options",
      "foreignKey": "survey_step_element_id",
      "name": "options",
      "macro": "has_many",
      "resource_name": "SurveyStepElementOption",
      "through": null
    },
    {
      "className": "ScoreFactor",
      "collectionName": "score_factors",
      "foreignKey": "score_factor_id",
      "name": "score_factor",
      "macro": "belongs_to",
      "resource_name": "ScoreFactor",
      "through": null
    },
    {
      "className": "SurveyStep",
      "collectionName": "survey_steps",
      "foreignKey": "survey_step_id",
      "name": "step",
      "macro": "belongs_to",
      "resource_name": "SurveyStep",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "has_one",
      "resource_name": "Survey",
      "through": "step"
    },
    {
      "className": "TeamSurveyStepElement",
      "collectionName": "team_survey_step_elements",
      "foreignKey": "survey_step_element_id",
      "name": "team_survey_step_elements",
      "macro": "has_many",
      "resource_name": "TeamSurveyStepElement",
      "through": null
    },
    {
      "className": "SurveyStepElement::Translation",
      "collectionName": null,
      "foreignKey": "survey_step_element_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "content_piece_type_id",
      "column": {
        "default": null,
        "name": "content_piece_type_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "editable",
      "column": {
        "default": "1",
        "name": "editable",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "element_type",
      "column": {
        "default": null,
        "name": "element_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "identifier",
      "column": {
        "default": null,
        "name": "identifier",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "max_choices",
      "column": {
        "default": null,
        "name": "max_choices",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "min_choices",
      "column": {
        "default": null,
        "name": "min_choices",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "position",
      "column": {
        "default": "0",
        "name": "position",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "score_factor_id",
      "column": {
        "default": null,
        "name": "score_factor_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "state",
      "column": {
        "default": "draft",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "survey_step_id",
      "column": {
        "default": null,
        "name": "survey_step_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "ContentAbsoluteContainer",
      "collectionName": "content_absolute_containers",
      "foreignKey": "survey_step_element_id",
      "name": "content_absolute_container",
      "macro": "has_one",
      "resource_name": "ContentAbsoluteContainer",
      "through": null
    },
    {
      "className": "Content",
      "collectionName": "contents",
      "foreignKey": "resource_id",
      "name": "content_model",
      "macro": "has_one",
      "resource_name": "Content",
      "through": null
    },
    {
      "className": "ContentPieceType",
      "collectionName": "content_piece_types",
      "foreignKey": "content_piece_type_id",
      "name": "content_piece_type",
      "macro": "belongs_to",
      "resource_name": "ContentPieceType",
      "through": null
    },
    {
      "className": "Content",
      "collectionName": "contents",
      "foreignKey": "resource_id",
      "name": "contents",
      "macro": "has_many",
      "resource_name": "Content",
      "through": null
    },
    {
      "className": "SurveyStepElementOption",
      "collectionName": "survey_step_element_options",
      "foreignKey": "survey_step_element_id",
      "name": "options",
      "macro": "has_many",
      "resource_name": "SurveyStepElementOption",
      "through": null
    },
    {
      "className": "ScoreFactor",
      "collectionName": "score_factors",
      "foreignKey": "score_factor_id",
      "name": "score_factor",
      "macro": "belongs_to",
      "resource_name": "ScoreFactor",
      "through": null
    },
    {
      "className": "SurveyStep",
      "collectionName": "survey_steps",
      "foreignKey": "survey_step_id",
      "name": "step",
      "macro": "belongs_to",
      "resource_name": "SurveyStep",
      "through": null
    }
  ],
  "paramKey": "survey_step_element",
  "primaryKey": "id"
}

/** Frontend model for SurveyStepElement. */
export default class SurveyStepElement extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  content() {
    return this.readAttributeUnderscore("content")
  }

  /** @returns {boolean} */
  hasContent() {
    const value = this.content()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  contentPieceTypeId() {
    return this.readAttributeUnderscore("content_piece_type_id")
  }

  /** @returns {boolean} */
  hasContentPieceTypeId() {
    const value = this.contentPieceTypeId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  editable() {
    return this.readAttributeUnderscore("editable")
  }

  /** @returns {boolean} */
  hasEditable() {
    const value = this.editable()

    return this._isPresent(value)
  }

  /** @returns {string} */
  elementType() {
    return this.readAttributeUnderscore("element_type")
  }

  /** @returns {boolean} */
  hasElementType() {
    const value = this.elementType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  identifier() {
    return this.readAttributeUnderscore("identifier")
  }

  /** @returns {boolean} */
  hasIdentifier() {
    const value = this.identifier()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  minChoices() {
    return this.readAttributeUnderscore("min_choices")
  }

  /** @returns {boolean} */
  hasMinChoices() {
    const value = this.minChoices()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  maxChoices() {
    return this.readAttributeUnderscore("max_choices")
  }

  /** @returns {boolean} */
  hasMaxChoices() {
    const value = this.maxChoices()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {number} */
  position() {
    return this.readAttributeUnderscore("position")
  }

  /** @returns {boolean} */
  hasPosition() {
    const value = this.position()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  scoreFactorId() {
    return this.readAttributeUnderscore("score_factor_id")
  }

  /** @returns {boolean} */
  hasScoreFactorId() {
    const value = this.scoreFactorId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {any} */
  surveyStepId() {
    return this.readAttributeUnderscore("survey_step_id")
  }

  /** @returns {boolean} */
  hasSurveyStepId() {
    const value = this.surveyStepId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedElementType() {
    return this.readAttributeUnderscore("translated_element_type")
  }

  /** @returns {boolean} */
  hasTranslatedElementType() {
    const value = this.translatedElementType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  parsedContent() {
    return this.readAttributeUnderscore("parsed_content")
  }

  /** @returns {boolean} */
  hasParsedContent() {
    const value = this.parsedContent()

    return this._isPresent(value)
  }

  /** @returns {any} */
  parsedMainContent() {
    return this.readAttributeUnderscore("parsed_main_content")
  }

  /** @returns {boolean} */
  hasParsedMainContent() {
    const value = this.parsedMainContent()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  mainContent() {
    return this.readAttributeUnderscore("main_content")
  }

  /** @returns {boolean} */
  hasMainContent() {
    const value = this.mainContent()

    return this._isPresent(value)
  }

  /** @returns {any} */
  mainContentDa() {
    return this.readAttributeUnderscore("main_content_da")
  }

  /** @returns {boolean} */
  hasMainContentDa() {
    const value = this.mainContentDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  mainContentEn() {
    return this.readAttributeUnderscore("main_content_en")
  }

  /** @returns {boolean} */
  hasMainContentEn() {
    const value = this.mainContentEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  mainContentNo() {
    return this.readAttributeUnderscore("main_content_no")
  }

  /** @returns {boolean} */
  hasMainContentNo() {
    const value = this.mainContentNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  mainContentSe() {
    return this.readAttributeUnderscore("main_content_se")
  }

  /** @returns {boolean} */
  hasMainContentSe() {
    const value = this.mainContentSe()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameDa() {
    return this.readAttributeUnderscore("name_da")
  }

  /** @returns {boolean} */
  hasNameDa() {
    const value = this.nameDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameEn() {
    return this.readAttributeUnderscore("name_en")
  }

  /** @returns {boolean} */
  hasNameEn() {
    const value = this.nameEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameNo() {
    return this.readAttributeUnderscore("name_no")
  }

  /** @returns {boolean} */
  hasNameNo() {
    const value = this.nameNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameSe() {
    return this.readAttributeUnderscore("name_se")
  }

  /** @returns {boolean} */
  hasNameSe() {
    const value = this.nameSe()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  adminPreview(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "admin_preview",
        primaryKey: this.primaryKey(),
        collectionName: "survey_step_elements",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./content-absolute-container.js").default | null} */
  contentAbsoluteContainer() {
    return this._readHasOneReflection({modelClass: ContentAbsoluteContainer, reflectionName: "content_absolute_container"})
  }

  /** @returns {Promise<import("./content-absolute-container.js").default | null>} */
  loadContentAbsoluteContainer() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["survey_step_element_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "content_absolute_container",
        model: this,
        modelClass: ContentAbsoluteContainer
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./content-absolute-container.js").default | null>} */
  ensureContentAbsoluteContainerLoaded() {
    return this.ensureAssociationLoaded("content_absolute_container")
  }

  /** @returns {import("./content.js").default | null} */
  contentModel() {
    return this._readHasOneReflection({modelClass: Content, reflectionName: "content_model"})
  }

  /** @returns {Promise<import("./content.js").default | null>} */
  loadContentModel() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["resource_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "content_model",
        model: this,
        modelClass: Content
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./content.js").default | null>} */
  ensureContentModelLoaded() {
    return this.ensureAssociationLoaded("content_model")
  }

  /** @returns {import("./content-piece-type.js").default | null} */
  contentPieceType() {
    return this._readBelongsToReflection({modelClass: ContentPieceType, reflectionName: "content_piece_type"})
  }

  /** @returns {Promise<import("./content-piece-type.js").default | null>} */
  loadContentPieceType() {
    if (!("contentPieceTypeId" in this)) throw new Error("Foreign key method wasn't defined: contentPieceTypeId")

    const id = this.contentPieceTypeId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "content_piece_type",
        model: this,
        modelClass: ContentPieceType
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./content-piece-type.js").default | null>} */
  ensureContentPieceTypeLoaded() {
    return this.ensureAssociationLoaded("content_piece_type")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./content.js").default>} */
  contents() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["resource_id_eq"] = this.id()
    ransack["resource_type_eq"] = "SurveyStepElement"

    return new Collection(
      {
        reflectionName: "contents",
        model: this,
        modelClass: Content
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./content.js").default>>} */
  loadContents() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["resource_id_eq"] = this.id()
    ransack["resource_type_eq"] = "SurveyStepElement"

    return this._loadHasManyReflection(
      {
        reflectionName: "contents",
        model: this,
        modelClass: Content
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./content.js").default>>} */
  ensureContentsLoaded() {
    return this.ensureAssociationLoaded("contents")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./survey-step-element-option.js").default>} */
  options() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["survey_step_element_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "options",
        model: this,
        modelClass: SurveyStepElementOption
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./survey-step-element-option.js").default>>} */
  loadOptions() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["survey_step_element_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "options",
        model: this,
        modelClass: SurveyStepElementOption
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./survey-step-element-option.js").default>>} */
  ensureOptionsLoaded() {
    return this.ensureAssociationLoaded("options")
  }

  /** @returns {import("./score-factor.js").default | null} */
  scoreFactor() {
    return this._readBelongsToReflection({modelClass: ScoreFactor, reflectionName: "score_factor"})
  }

  /** @returns {Promise<import("./score-factor.js").default | null>} */
  loadScoreFactor() {
    if (!("scoreFactorId" in this)) throw new Error("Foreign key method wasn't defined: scoreFactorId")

    const id = this.scoreFactorId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "score_factor",
        model: this,
        modelClass: ScoreFactor
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./score-factor.js").default | null>} */
  ensureScoreFactorLoaded() {
    return this.ensureAssociationLoaded("score_factor")
  }

  /** @returns {import("./survey-step.js").default | null} */
  step() {
    return this._readBelongsToReflection({modelClass: SurveyStep, reflectionName: "step"})
  }

  /** @returns {Promise<import("./survey-step.js").default | null>} */
  loadStep() {
    if (!("surveyStepId" in this)) throw new Error("Foreign key method wasn't defined: surveyStepId")

    const id = this.surveyStepId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "step",
        model: this,
        modelClass: SurveyStep
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./survey-step.js").default | null>} */
  ensureStepLoaded() {
    return this.ensureAssociationLoaded("step")
  }
}
